/* eslint-disable react/jsx-filename-extension */
/* eslint-disable react/react-in-jsx-scope */
import { useCallback, useEffect, useState } from 'react';
import moment from 'moment';
import { Modal } from 'antd';
import { CustomText } from '@4beefopag/4bee-fopag-core/dist/atoms';
import { mostrarErro } from '@4beefopag/4bee-fopag-core/dist/molecules';
import { buscarParametrizacaoFolha, APONTAMENTO } from '../index';
import { findById, rejectReopen } from '../../repository/payrollRepository';

/**
 * Hook para gerenciar requisições de apontamento
 */
export const useApontamentoRequisicao = (payrollIdParam, setSelectedCollaborators) => {
  const [payroll, setPayroll] = useState(undefined);
  const [loadingCollaborators, setLoadingCollaborators] = useState(false);
  const [parameterization, setParameterization] = useState({});
  const [company, setCompany] = useState(undefined);
  const [competence, setCompetence] = useState(undefined);
  const [type, setType] = useState(APONTAMENTO.tiposRequisicoes.mensal);
  const [competences, setCompetences] = useState([
    { comp: moment().format('MM/YYYY') },
    { comp: moment().add(1, 'M').format('MM/YYYY') },
  ]);

  const fetchPayroll = useCallback(async (id, setSelectedCollaboratorsCb) => {
    setLoadingCollaborators(true);
    try {
      const payrollFound = await findById(id);
      setPayroll(payrollFound);
      if (setSelectedCollaboratorsCb) {
        setSelectedCollaboratorsCb(payrollFound.items.map((m) => m.cooperator.id));
      }

      if (payrollFound.hasSomeChangeOnEarningValues) {
        Modal.warning({
          centered: true,
          width: 560,
          title: (
            <CustomText
              color="var(--text-grey-8)"
              fontSize={16}
            >
              Apdata foi atualizado
            </CustomText>
          ),
          okText: 'Fechar',
          content: <p>Foram obtidos novos dados de remuneração do Apdata</p>,
        });
      }

      return payrollFound;
    } finally {
      setLoadingCollaborators(false);
    }
  }, []);

  const selectParameterization = useCallback(async (companyId, competenceToSelect) => {
    const param = await buscarParametrizacaoFolha(companyId, competenceToSelect);
    setParameterization(param);
    setCompetences([{ comp: moment().format('MM/YYYY') }, { comp: moment().add(1, 'M').format('MM/YYYY') }]);

    if (param?.atual_comp_ap) {
      const parameterizationDate = moment().set('date', param.atual_comp_ap_qtd_dias);
      const currentDate = moment();
      if (parameterizationDate.isAfter(currentDate)) {
        setCompetences([{ comp: moment().subtract(1, 'M').format('MM/YYYY') }, { comp: moment().format('MM/YYYY') }]);
      }
    }
  }, []);

  useEffect(() => {
    (async () => {
      if (payrollIdParam) {
        const id = payrollIdParam.replace(/\D/g, '');
        const payrollFound = await fetchPayroll(id, setSelectedCollaborators);
        setCompany(payrollFound.folha);
        setCompetence(moment(payrollFound.competencia, 'YYYY-MM-DD').format('MM/YYYY'));
        setType(payrollFound.tipo);

        const param = await buscarParametrizacaoFolha(
          payrollFound.folha.id,
          moment(payrollFound.competencia, 'YYYY-MM-DD')
        );
        setParameterization(param);

        if (payrollIdParam.includes('x') && payrollFound.status === APONTAMENTO.status.reabertura_pendente) {
          try {
            await rejectReopen(id);
            Modal.success({
              title: 'Sucesso',
              content:
                'Pedido de Reabertura Recusado com sucesso, em instantes o gestor responsável receberá um e-mail para informar o status do pedido.',
            });
            await fetchPayroll(id, setSelectedCollaborators);
          } catch (err) {
            mostrarErro(err);
          }
        }
      }
    })();
  }, [payrollIdParam]);

  const clearForm = useCallback(() => {
    setCompany(undefined);
    setPayroll(undefined);
    setCompetence(undefined);
    setParameterization({});
  }, []);

  return {
    payroll,
    setPayroll,
    loadingCollaborators,
    parameterization,
    setParameterization,
    company,
    setCompany,
    competence,
    setCompetence,
    type,
    setType,
    competences,
    fetchPayroll,
    selectParameterization,
    clearForm,
  };
};
